import React from "react";

export default function MtfArrow() {
  return (
    <svg width="45" height="24" viewBox="0 0 51 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M50.0607 13.0607C50.6464 12.4749 50.6464 11.5251 50.0607 10.9393L40.5147 1.3934C39.9289 0.807611 38.9792 0.807611 38.3934 1.3934C37.8076 1.97919 37.8076 2.92893 38.3934 3.51472L46.8787 12L38.3934 20.4853C37.8076 21.0711 37.8076 22.0208 38.3934 22.6066C38.9792 23.1924 39.9289 23.1924 40.5147 22.6066L50.0607 13.0607ZM0 13.5H49V10.5H0V13.5Z"
        fill="#FBFBF7"
      />
    </svg>
  );
}
